<template>
  <div class="ReactModalPortal error-modal">
    <div class="ReactModal__Overlay ReactModal__Overlay--after-open" class-open="ReactModal__Overlay--after-open"
         aria-modal="true">
      <div
        class="ReactModal__Content overlay xs-full-height xs-full-width xs-mb-0 xs-flex xs-items-center ReactModal__Content--after-open"
        class-open="ReactModal__Content--after-open" tabindex="-1" aria-label="DelayedOrderModal">
        <div class="xs-overflow-auto" style="width: 100%; height: 100%;">
<!--          <button class="icon-close&#45;&#45;white xs-p-20 xs-absolute xs-r-20 xs-t-10 close-error-popup"-->
<!--                  @click="$emit('close')"></button>-->
          <div class="xs-pt-60 xs-px-40 xs-text-white xs-text-center">
            <p>
              <span v-if="message" class="error-message bold"
                    style="font-size: 20px;">{{message}}</span>
            </p>
            <p>
            </p></div>
            <div class="display-flex btn-action-store">
                <div class="xs-px-20 p-10 xs-b-0 xs-l-0 xs-r-0 xs-fill-black-70 md-static md-fill-none flex-1"
                     v-if="isProcessOrder">
                    <button class="button button--green xs-text-center button-bottom" @click="$emit('close')">
                        <span>{{$t('modal.process_order')}}</span></button>
                </div>
                <div class="xs-px-20 p-10 xs-b-0 xs-l-0 xs-r-0 xs-fill-black-70 md-static md-fill-none flex-1"
                     v-if="isRedirect">
                    <button class="button button--green xs-text-center button-bottom" @click="actionHandle($const.CARRYOUT)">
                      <span>{{$t('modal.search_collection')}}</span></button>
                </div>
                <div class="xs-px-20 p-10 xs-b-0 xs-l-0 xs-r-0 xs-fill-black-70 md-static md-fill-none flex-1"
                     v-if="isShowAdvanceTime">
                    <button class="button button--green xs-text-center button-bottom" @click="selectAdvanceTime()">
                      <span>{{$t('modal.select_advance_time')}}</span></button>
                </div>
                <div class="xs-px-20 p-10 xs-b-0 xs-l-0 xs-r-0 xs-fill-black-70 md-static md-fill-none flex-1"
                     v-if="isChooseAnotherAddress">
                    <button class="button button--green xs-text-center button-bottom close-error-popup" @click="actionHandle($const.DELIVERY)">
                      <span>{{$t('modal.choose_different_delivery')}}</span></button>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions} from 'vuex'
import * as action from '../../store/actions'
import ASAPPopup from './OrderASAP'

export default {
  props: {
    message: {
      type: String,
      required: true
    },
    isProcessOrder: {
      type: Boolean,
      default: false
    },
    isRedirect: {
      type: Boolean,
      default: false
    },
    isShowAdvanceTime: {
      type: Boolean,
      default: false
    },
    isChooseAnotherAddress: {
      type: Boolean,
      default: false
    },
    outletId : {
        type : Number,
        required: false
    },
    orderType : {
        ype : String,
        required: false
    },
    outletDataLocalization : {
        type : Object,
        required: false
    },
  },
  methods: {
    ...mapActions({
      setDisposition: action.SET_DISPOSITION
    }),
    resetCart() {
      this.$session.remove('cart')
      this.$session.remove('disposition')
      this.setDisposition({})
      this.$root.$emit('cartUpdate')
    },
    selectAdvanceTime () {
      this.$emit('close')
      this.$modal.show(ASAPPopup, {
          message : this.$t('placing_advance_order'),
          outletId: this.outletId,
          orderType: this.orderType,
          outletDataLocalization: this.outletDataLocalization
      }, {class: ''})
    },
    /**
     * Trigger click tab take-away/ delivery
     * */
    actionHandle: function (type) {
      this.resetCart()
      this.$emit('close')
      if (this.isRedirect) {
        let defaultType = 'collection'
        if (type === this.$const.DELIVERY) {
          defaultType = 'delivery'
        }
        if (this.$route.name === 'home') {
          this.$root.$emit('activeTabLocalization', type)
        } else {
          this.$router.push({'name': 'home', query: {orderTypeDefault: defaultType}})
        }
      }
    }
  }
}
</script>
<style>
.error-message a:hover{
  color: #337ab7;
}
    @media screen and (max-width: 800px)  {
        .btn-action-store {
            flex-direction: column;
        }
        .btn-action-store .button {
            padding: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalActionError.vue